module.exports = __webpack_public_path__ + "static/media/06-上海市鹤龙美术馆.81f0268d.png";